export const fmtCurrency = (v, cur = "USD") => {
  if (v == null || isNaN(v)) return "-";
  const n = Number(v);
  const abs = Math.abs(n);
  const sign = cur === "AUD" ? "A$" : "$";
  if (abs >= 1e9) return `${sign}${(n / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}${(n / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${sign}${(n / 1e3).toFixed(1)}K`;
  return `${sign}${n.toFixed(2)}`;
};

export const fmtNum = (v, d = 0) => {
  if (v == null || isNaN(v)) return "-";
  return Number(v).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtPct = (v, d = 2) => {
  if (v == null || isNaN(v)) return "-";
  const n = Number(v);
  return `${n >= 0 ? "+" : ""}${n.toFixed(d)}%`;
};

export const marketPill = (m) => {
  const cls = m === "ASX" ? "pill pill-asx" : m === "NYSE" ? "pill pill-nyse" : "pill pill-nasdaq";
  return cls;
};

export const scoreColor = (s) => {
  if (s >= 0.7) return "var(--score-high)";
  if (s >= 0.5) return "var(--score-med)";
  return "var(--score-low)";
};

export const scoreChipClass = (s) => {
  if (s >= 0.7) return "score-chip high";
  if (s >= 0.5) return "score-chip med";
  return "score-chip low";
};

export const kindLabel = (k) => k.replace(/_/g, " ").toUpperCase();
